export const AxisLeft = ({yScale, innerWidth, tickFormat, tickOffset = 3, ticks}) =>
  (ticks ?? yScale.ticks()).map((tickValue) => (
    <g className="tick" key={tickValue} transform={`translate(0,${yScale(tickValue)})`}>
      <line x2={innerWidth} />
      <text
        style={{ textAnchor: 'end' }}
        dy=".32em"
        x={-tickOffset}
      >
        {tickFormat(tickValue)}
      </text>
    </g>

  ));
